import { ACTS, resolveActById } from '@/constants/acts'
import { useSceneStore } from '@/stores/scene-store'

const VISIBLE_FROM = 0.015
const VISIBLE_UNTIL = 0.99
const TOTAL_ACTS = ACTS.length

export function useActIndicatorModel() {
  const activeActId = useSceneStore((state) => state.activeActId)
  const rawProgress = useSceneStore((state) => state.rawProgress)

  const currentAct = resolveActById(activeActId)
  const position = ACTS.indexOf(currentAct) + 1

  return {
    actLabel: currentAct.label,
    positionText: `${position} de ${TOTAL_ACTS}`,
    ariaLabel: `Etapa ${position} de ${TOTAL_ACTS}: ${currentAct.label}`,
    isVisible: rawProgress > VISIBLE_FROM && rawProgress < VISIBLE_UNTIL,
  }
}
